import React from "react";
import { Navigate } from "react-router-dom";

const KnowledgeBaseWrapper = () => {
  return <Navigate to="/knowledge-base/list" />;
};

export default KnowledgeBaseWrapper;
